import React from 'react'

import { Select, positions, basis } from '.'

import EditPostContainer, {
  CommonContainerProps
} from 'containers/EditPostContainer'
import { TextRadioForm } from 'components/RadioForm'
import LighterText from 'components/Text/Lighter'
import { Container, Wrapper } from './Position.style'
import ErrorText from 'components/Text/ErrorText'

interface SelectionType {
  position: Select
  basis: Select
}

interface PositionProps extends CommonContainerProps<SelectionType> {
  initPosition?: Select
  initBasis?: Select
}

export default class Position extends React.Component<PositionProps> {
  state: {
    selectedPosition: Select
    selectedBasis: Select
  } = {
    selectedPosition: this.props.initPosition as Select,
    selectedBasis: this.props.initBasis as Select
  }

  setPosition(position: Select) {
    this.setState({ selectedPosition: position })
  }

  setBasis(basis: Select) {
    this.setState({ selectedBasis: basis })
  }

  render() {
    return (
      <EditPostContainer
        progressValue={12}
        title='Position'
        {...this.props}
        onNext={() => {
          return this.props.onNext({
            basis: this.state.selectedBasis,
            position: this.state.selectedPosition
          })
        }}
        isNextAvailable={
          !!(this.state.selectedBasis && this.state.selectedPosition)
        }
      >
        <Container>
          <Wrapper>
            <LighterText>Position</LighterText>
            {!(this.state.selectedPosition && this.state.selectedBasis) && (
              <ErrorText>
                You must select position and basis to continue
              </ErrorText>
            )}

            <TextRadioForm
              items={positions}
              selected={this.state.selectedPosition as Select}
              onSelected={selected => this.setPosition(selected)}
            />
          </Wrapper>
          <Wrapper>
            <LighterText>Basis</LighterText>
            <TextRadioForm
              items={basis}
              selected={this.state.selectedBasis as Select}
              onSelected={selected => this.setBasis(selected)}
            />
          </Wrapper>
        </Container>
      </EditPostContainer>
    )
  }
}
